/**
 * Validates an HTML date input value and returns yyyy-MM-dd for trial_membership.trial_start_date.
 */
export function normalizeTrialStartDateForApi(dateInput: string): string {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateInput.trim());
  if (!match) {
    throw new Error('Invalid trial booking date format');
  }

  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const localMidnight = new Date(year, month - 1, day, 0, 0, 0, 0);

  if (
    localMidnight.getFullYear() !== year ||
    localMidnight.getMonth() !== month - 1 ||
    localMidnight.getDate() !== day
  ) {
    throw new Error('Invalid trial booking date');
  }

  return `${match[1]}-${match[2]}-${match[3]}`;
}

/** Local calendar today as YYYY-MM-DD for date input min. */
export function localTodayDateInputValue(): string {
  const now = new Date();
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, '0');
  const d = String(now.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}
